var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9937 18.9844C28.9937 19.5469 28.525 19.9875 27.9937 19.9875H26.9937L27.0156 24.9937C27.0156 25.0781 27.0094 25.1625 27 25.2469V25.75C27 26.4406 26.4406 27 25.75 27H25.25C25.2156 27 25.1813 27 25.1469 26.9969C25.1031 27 25.0594 27 25.0156 27H24H23.25C22.5594 27 22 26.4406 22 25.75V25V23C22 22.4469 21.5531 22 21 22H19C18.4469 22 18 22.4469 18 23V25V25.75C18 26.4406 17.4406 27 16.75 27H16H15.0031C14.9563 27 14.9094 26.9969 14.8625 26.9937C14.825 26.9969 14.7875 27 14.75 27H14.25C13.5594 27 13 26.4406 13 25.75V22.25C13 22.2219 13 22.1906 13.0031 22.1625V19.9875H12C11.4375 19.9875 11 19.55 11 18.9844C11 18.7031 11.0938 18.4531 11.3125 18.2344L19.325 11.25C19.5437 11.0312 19.7937 11 20.0125 11C20.2312 11 20.4812 11.0625 20.6687 11.2188L28.65 18.2344C28.9 18.4531 29.025 18.7031 28.9937 18.9844Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.2cb8bc1ecdceb8ada181639227d3fc83.svg";
export { ForwardRef as ReactComponent };